export const buildChecklistItemKey = (item) => {
  const identity = [
    item?.id || item?._id || '',
    item?.client_name || item?.client || '',
    item?.sku || '',
    item?.description || '',
    item?.variant || item?.color || '',
    item?.size || item?.talle || item?.talla || '',
    item?.status || '',
    Number(item?.quantity || 0)
  ];

  return identity.join('|');
};

export const summarizeChecklistForItems = (items = [], checklist = {}) => {
  const normalized = Array.isArray(items) ? items : [];
  const totalItems = normalized.length;
  const completedItems = normalized.reduce((acc, item) => {
    const key = item?._rowKey || buildChecklistItemKey(item);
    return checklist[key]?.checked ? acc + 1 : acc;
  }, 0);

  const ordered = normalized.reduce((acc, item) => acc + Number(item?.quantity || 0), 0);
  const received = normalized.reduce((acc, item) => {
    const key = item?._rowKey || buildChecklistItemKey(item);
    return acc + Number(checklist[key]?.received || 0);
  }, 0);

  return {
    totalItems,
    completedItems,
    ordered,
    received,
    isComplete: totalItems > 0 && completedItems === totalItems && received >= ordered
  };
};
